export default __webpack_public_path__ + "static/media/mobile_app_responsive.15f8abfa.svg";